import { Component, OnInit, AfterViewInit } from "@angular/core";
import { ReportService } from "../report.service";
//Import Custom Services Here
import { GradeLevelService } from "../report-services/grade-level.service";
import { AcademyService } from "../report-services/academy.service";
import { HomeroomService } from "../report-services/homeroom.service";
import { GroupService } from "../report-services/group.service";
import { SchoolService } from "../../../shared/services/school.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { DialogService } from "primeng/dynamicdialog";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";
import * as moment from "moment";

@Component({
	templateUrl: "./studentcutsmtdytd.component.html",
})
export class StudentCutsMTDYTDComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private reportService: ReportService,
		//Insert Custom Services Here
		private groupService: GroupService,
		private homeroomService: HomeroomService,
		private academyService: AcademyService,
		private gradelevelService: GradeLevelService,
		private schoolService: SchoolService,
		private dialogService: DialogService
	) {}
	report = {
		SchoolID: 0,
		//Insert Custom Parameters Here
		//SchoolXML: "",
		GradeLevelID: 0,
		AcademyID: 0,
		HomeroomID: 0,
		GroupID: 0,
		GivenDate: new Date(),
		ShowTypeID: "All With Cuts",
		ShowDetailID: "Yes",
		OrderByID: "Academy",
		ImageLogo: "",
	};

	//Insert Custom Lists Here
	GradeLevelList: any = [];
	AcademyList: any = [];
	HomeroomList: any = [];
	GroupList: any = [];
	ImageLogoList: any = [];
	schoolList: any = [];

	SchoolSelectShowAllID: any = 0;
	SchoolSelectShowAllText: any = "All Schools";

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;

	ShowTypeList = [
		//Insert Custom List Items Here
		{
			ShowTypeID: "All With Cuts",
			ShowTypeName: "All With Cuts",
		},
		{
			ShowTypeID: "All With Cuts On Given Date",
			ShowTypeName: "All With Cuts On Given Date",
		},
	];

	ShowDetailList = [
		//Insert Custom List Items Here
		{
			ShowDetailID: "Yes",
			ShowDetailName: "Yes",
		},
		{
			ShowDetailID: "No",
			ShowDetailName: "No",
		},
	];

	OrderByList = [
		//Insert Custom List Items Here
		{
			OrderByID: "Academy",
			OrderByName: "Academy",
		},
		{
			OrderByID: "Grade",
			OrderByName: "Grade",
		},
		{
			OrderByID: "Homeroom",
			OrderByName: "Homeroom",
		},
		{
			OrderByID: "Name",
			OrderByName: "Name",
		},
		{
			OrderByID: "YTD Cuts",
			OrderByName: "YTD Cuts",
		},
	];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	ReportID: number = 19;

	subscription: any;

	ngOnInit() {
		//Insert Custom Init Methods Here
		// this.loadSchoolist()
		// this.loadGradeLevelList()
		// this.loadAcademyList()
		// this.loadHomeroomList()
		// this.loadGroupList()

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	onSchoolChange(value) {
		this.report.SchoolID = value;
		this.loadGradeLevelList();
		this.loadAcademyList();
		this.loadHomeroomList();
		this.loadGroupList();
		this.loadLogolist();
	}

	private loadSchoolist() {
		var result = this.schoolService.GetSchoolsForUserReport(19);
		result.subscribe(
			(response) => {
				this.schoolList = response;

				if (this.schoolList.length > 1) {
					this.schoolList.unshift({
						SchoolID: 0,
						SchoolName: "All Schools",
					});
				} else {
					this.onSchoolChange(this.schoolList[0].SchoolID);
				}
			},
			(error) => {}
		);
	}

	private loadGradeLevelList() {
		this.report.GradeLevelID = 0;
		var result = this.gradelevelService.loadGradeLevelList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.GradeLevelList = response;

				if (this.GradeLevelList.length >= 0) {
					// this.GradeLevelList.unshift({
					//     GradeLevelID: 0,
					//     GradeLevelDesc: "All Grades"
					// })
				} else {
					this.report.GradeLevelID = this.GradeLevelList[0].GradeLevelID;
				}
			},
			(error) => {}
		);
	}

	private loadAcademyList() {
		this.report.AcademyID = 0;
		var result = this.academyService.loadAcademyList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.AcademyList = response;

				if (this.AcademyList.length >= 0) {
					// this.AcademyList.unshift({
					//     AcademyID: 0,
					//     AcademyDesc: "All Academies"
					// })
					this.report.AcademyID = this.AcademyList[0].AcademyId;
				} else {
					this.report.AcademyID = this.AcademyList[0].AcademyId;
				}
			},
			(error) => {}
		);
	}

	private loadHomeroomList() {
		this.report.HomeroomID = 0;
		var result = this.homeroomService.loadHomeroomList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.HomeroomList = response;

				if (this.HomeroomList.length >= 0) {
					// this.HomeroomList.unshift({
					//     HomeroomId: 0,
					//     HomeRoom: "All Homerooms"
					// })
				} else {
					this.report.HomeroomID = this.HomeroomList[0].HomeroomId;
				}
			},
			(error) => {}
		);
	}

	private loadGroupList() {
		this.report.GroupID = 0;
		var result = this.groupService.loadGroupList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.GroupList = response;

				if (this.GroupList.length >= 0) {
					// this.GroupList.unshift({
					//     GroupID: 0,
					//     GroupName: "All Groups"
					// })
					this.report.GroupID = this.GroupList[0].GroupID;
				} else {
					this.report.GroupID = this.GroupList[0].GroupID;
				}
			},
			(error) => {}
		);
	}

	private loadLogolist() {
		var result = this.reportService.ImageLogoGetList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.ImageLogoList = response;

				this.report.ImageLogo = this.ImageLogoList[0].ImageLibraryID;
			},
			(error) => {}
		);
	}

	Print() {
		var component = this;
		this.errorMessage = "";

		//Insert Custom Error Checks Here
		// if (!this.report.SchoolXML) {
		// 	this.errorMessage = "Select the SchoolXML"
		// 	return;
		// }

		// if (!this.report.GradeLevelID) {
		// 	this.errorMessage = "Select the GradeLevel"
		// 	return;
		// }

		// if (!this.report.AcademyID) {
		// 	this.errorMessage = "Select the Academy"
		// 	return;
		// }

		// if (!this.report.HomeroomID) {
		// 	this.errorMessage = "Select the Homeroom"
		// 	return;
		// }

		// if (!this.report.GroupID) {
		// 	this.errorMessage = "Select the Group"
		// 	return;
		// }

		// if (!this.report.GivenDate) {
		// 	this.errorMessage = "Select the GivenDate"
		// 	return;
		// }

		// if (!this.report.ShowTypeID) {
		// 	this.errorMessage = "Select the ShowType"
		// 	return;
		// }

		// if (!this.report.ShowDetailID) {
		// 	this.errorMessage = "Select the ShowDetail"
		// 	return;
		// }

		// if (!this.report.OrderByID) {
		// 	this.errorMessage = "Select the OrderBy"
		// 	return;
		// }

		var strParam = this.GetStrParam();
		this.isProcessing = true;

		var reportID = 19;

		var result = this.reportService.Print(reportID, strParam, this.report.SchoolID, this.OutputTypeID);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		//Parameter 1: SchoolXML
		strParam += "<ROOT><School SchoolID='" + this.report.SchoolID + "'/></ROOT>" + "|SchoolXML";

		//Parameter 2: GradeLevelID
		strParam += "," + this.report.GradeLevelID + "|GradeLevelID";

		//Parameter 3: AcademyID
		strParam += "," + this.report.AcademyID + "|AcademyID";

		//Parameter 4: HomeroomID
		strParam += "," + this.report.HomeroomID + "|HomeroomID";

		//Parameter 5: GroupID
		strParam += "," + this.report.GroupID + "|GroupID";

		//Parameter 6: GivenDate
		strParam += "," + moment(this.report.GivenDate).format("MM/DD/YYYY") + "|GivenDate";

		//Parameter 7: ShowType
		strParam += "," + this.report.ShowTypeID + "|ShowType";

		//Parameter 8: ShowDetail
		strParam += "," + this.report.ShowDetailID + "|ShowDetail";

		//Parameter 9: OrderBy
		strParam += "," + this.report.OrderByID + "|OrderBy";

		//Parameter 10: ImageLogo
		strParam += "," + this.report.ImageLogo + "|Imagelogo";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
